import { Value } from 'components/ShareSheet/RecipientSelector/Types'
import { ReviewerRole, ReviewType } from './types'

export type ReviewTypeConfig = {
  reviewers: Value[]
  approvers: Value[]
  viewers?: Value[]
}

export const defaultRolesFromReviewType = (reviewType: ReviewType) => {
  switch (reviewType) {
    case ReviewType.APPROVAL:
      return ReviewerRole.APPROVER
    case ReviewType.FEEDBACK:
      return ReviewerRole.REVIEWER
    case ReviewType.READ_RECEIPTS:
      return ReviewerRole.VIEWER
    default:
      return ReviewerRole.REVIEWER
  }
}

export const reviewRolesFromReviewTypeAndConfig = (reviewType: ReviewType, config: ReviewTypeConfig) => {
  const roles = []
  config.reviewers.length > 0 && roles.push(ReviewerRole.REVIEWER)
  config.approvers.length > 0 && roles.push(ReviewerRole.APPROVER)
  config.viewers && config.viewers.length > 0 && roles.push(ReviewerRole.VIEWER)
  if (roles.length === 0) roles.push(defaultRolesFromReviewType(reviewType))
  return roles
}
